module.exports = __webpack_public_path__ + "img/selesai.aa602863.svg";